var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReportPage',{attrs:{"company-id":_vm.companyId,"type":_vm.type,"path":_vm.path}})
}
var staticRenderFns = []

export { render, staticRenderFns }